import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import EmbeddedAttachment from './EmbeddedAttachment';

@injectIntl
@connect(state => ({
  lesson: state.lessonDetails.lesson,
  offline: state.online.offline,
}))
export default class EmbeddedAttachments extends React.Component {
  static propTypes = {
    lesson: PropTypes.shape({
      attachments: PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
          type: PropTypes.string.isRequired,
          size: PropTypes.number.isRequired,
          uploadedDate: PropTypes.string.isRequired,
          path: PropTypes.string.isRequired,
          mimetype: PropTypes.string.isRequired,
        }),
      ),
    }).isRequired,
    withVideo: PropTypes.bool.isRequired,
    offline: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    apiUrl: PropTypes.string,
  };

  render() {
    const {
      lesson,
      withVideo,
      offline,
      // intl: { formatMessage },
    } = this.props;

    const attachments = _.filter(lesson.attachments, 'isEmbedded');

    if (!_.get(attachments, 'length') || offline) {
      return null;
    }

    return (
      <>
        {attachments.map((item, index) => (
          <EmbeddedAttachment
            key={item._id}
            item={item}
            withVideo={withVideo}
            isLast={index === attachments.length - 1}
          />
        ))}
      </>
    );
  }
}
